exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".custom-template-unavailable {\n    display: flex;\n    text-align: left;\n    font-size: 14px;\n    font-weight: normal;\n    margin-top: 0.2rem;\n    margin-right: -12px;\n    color: red;\n}\n", ""]);
